<template>
    <ModalSendMail
        v-bind:TitleWindow="'Send by E-Mail'"
        @ModalClickOk="sendEmailClick"  
        v-bind:ModalId="modalSendMail"
        v-bind:Subject="conformSubject"
        v-bind:Cc="cc"
        v-bind:To="to"
        v-bind:Body="body">
    </ModalSendMail>
</template>

<script>
import GlobalService from '@/services/global.service'
import ShowMessage from '@/components/messages/ShowMessage.js'

export default {
    name: 'CSVExportHelper',
    mixins: [ShowMessage],

    props: { 
        conformSubject: String,
        sendEmailAPI: String,
        exportCsvAPI: String
    },

    data() {
        return {
            modalSendMail: "SendMailId",
            parameters: {},
            sendPdfEmail: false,
            pdfParameters: {},
            cc:'',
            body:'',
            to:'',
            url: '',
        }
    },

    methods: {
        async exportCSV(parameters) {
            try {
                this.parameters = {...parameters};
                this.parameters.PageNumber = null;
                this.parameters.PageSize = null;

                const response = await GlobalService.exportCSV(this.exportCsvAPI, this.parameters);
                
                if (response.data) {
                    if (response.data.isEmpty) {
                        this.showMessage(this.$t('rClinicalNotes.ExpReport'), this.$t('Msg.nRecExport'), 'warning');
                        return; 
                    }
                    
                    var baseurl = this.$store.state.apiurl.replace('/api/', '');
                    await this.exportFromUrl(baseurl + response.data.url, response.data.fileName);
                }
                return response;
                
            } catch (error) {
                this.showResponseErrorMessage(error);
                throw error;
            }
        },

        async exportFromUrl(url, filename) {          
            const data = await fetch(url)
            const blob = await data.blob()
            const objectUrl = URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.setAttribute('href', objectUrl)
            link.setAttribute('download', filename)
            link.style.display = 'none'
            document.body.appendChild(link)                          
            link.click()                          
            document.body.removeChild(link)
        },

        async emailCSV(parameters) {
     
            this.parameters = {...parameters};
            this.parameters.PageNumber = null;
            this.parameters.PageSize = null;

            // 1. First export the CSV and get the URL
            const response = await GlobalService.exportCSV(this.exportCsvAPI, this.parameters);
            
            // 2.Check if there is no data
            if (response.data.isEmpty) {
                this.showMessage(
                    this.$t('rClinicalNotes.ExpReport'), 
                    this.$t('Msg.nRecExport'), 
                    'warning'
                );
                return; // Exit without displaying modal
            }
            
            // 3. Save the CSV URL for later use
            this.url = response.data.url;
            
            // 4. Show email submission modal
            this.sendPdfEmail = false;
            this.to = '';
            this.cc = '';
            this.body = '';
            this.$bvModal.show(this.modalSendMail);
        },

        async sendEmailClick(To, Cc, Subject, Body) {
            if (this.sendPdfEmail) {
                return this.sendPdfEmailClick(To, Cc, Subject, Body);
            }

            let params = {
                // ...this.parameters,
                to: To,
                cc: Cc ? Cc : null,
                subject: Subject,
                body: Body ? Body : null,
                url: this.url ? this.url : null
            };

            this.to = To;
            this.cc = Cc;
            this.body = Body;

            await GlobalService
                .sendEmail(this.sendEmailAPI, params)
                .then(response => {
                    if (response.data.success == true)
                        this.showMessage(this.$t('Shared.SharedEmailCSV'), this.$t('Shared.Esent'));
                    else 
                        this.showMessage(this.$t('Shared.SharedEmailCSV'), response.data.errorMessage, "error");
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async exportToPdf(reportName, isAnAPIReport, isANotesReport, params) {
            try {
                const response = await GlobalService.exportToPdf({
                    reportName: reportName, 
                    isAnAPIReport: isAnAPIReport, 
                    isANotesReport: isANotesReport
                }, params);
                
                if (response.data) {
                    if (response.data.isEmpty) {
                        this.showMessage(this.$t('rClinicalNotes.ExpReport'), this.$t('Msg.nRecExport'), 'warning');
                        return;
                    }
                    
                    var baseurl = this.$store.state.apiurl.replace('/api/', '');
                    await this.exportFromUrl(baseurl + response.data.url, response.data.fileName);
                }
            } catch (error) {
                this.showResponseErrorMessage(error);
            }
        },

        async emailPdf(reportName, isAnAPIReport, isANotesReport, parameters) {
            try {
                // 1. First export the PDF and get the URL
                const exportResponse = await GlobalService.exportToPdf({
                    reportName: reportName, 
                    isAnAPIReport: isAnAPIReport, 
                    isANotesReport: isANotesReport
                }, parameters);
                
                // 2. Check if there is no data
                if (exportResponse.data.isEmpty) {
                    this.showMessage(
                        this.$t('rClinicalNotes.ExpReport'), 
                        this.$t('Msg.nRecExport'), 
                        'warning'
                    );
                    return; // Exit without displaying modal
                }
                
                // 3. Save the PDF URL for later use
                this.url = exportResponse.data.url;
             
                // 4. Mostrar modal de envío de email
                // this.pdfParameters = {
                //     reportName: reportName, 
                //     isAnAPIReport: isAnAPIReport, 
                //     isANotesReport: isANotesReport
                // };
                this.sendPdfEmail = true;
                // this.parameters = [...parameters];
                this.to = '';
                this.cc = '';
                this.body = '';
             
                this.$bvModal.show(this.modalSendMail);
                
            } catch (error) {
                this.showResponseErrorMessage(error);
            }
        },

        async sendPdfEmailClick(To, Cc, Subject, Body) {
            let params = {
                // ...this.pdfParameters,
                to: To,
                cc: Cc ? Cc : null,
                subject: Subject,
                body: Body ? Body : null,
                url: this.url ? this.url : null
            };

            this.to = To;
            this.cc = Cc;
            this.body = Body;

            await GlobalService
                .sendPdfEmail(params)
                .then(response => {
                    if (response.data.success == true)
                        this.showMessage(this.$t('Shared.SharedEmailPDF'), this.$t('Shared.Esent'));
                    else 
                        this.showMessage(this.$t('Shared.SharedEmailPDF'), response.data.errorMessage, "error");
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        }
    }
}
</script>
